import { render } from "./IbanMissing.vue?vue&type=template&id=182d5094"
import script from "./IbanMissing.vue?vue&type=script&lang=js"
export * from "./IbanMissing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__